// Loader.js

import React, { useEffect } from 'react';
import LG1 from '../../assets/loading.gif';


const Loader = ({ loading }) => {
  useEffect(() => {
    const body = document.querySelector('body');
    body.style.overflow = loading ? 'hidden' : 'auto';

    // Cleanup function to restore the original overflow style
    return () => {
      body.style.overflow = 'auto';
    };
  }, [loading]);

  return loading && (
    <div className='loader-css loader-div'>
      <img src={LG1} alt="" width="100px" style={{ backgroundColor: "transparent" }} />
    </div>
  );
};

export default Loader;
